import 'babel-polyfill';
import 'dom4';
import 'bootstrap';
import 'fontawesome-iconpicker';
import 'select2';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import 'vue-select/dist/vue-select.css';
import 'bootstrap';
import 'select2';
import 'fontawesome-iconpicker';
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor';
import VueTagsInput from '@johmun/vue-tags-input';
import { QuillEditor } from '@vueup/vue-quill';
import axios from 'axios';
import beautify from 'beautify';
import * as Choices from 'choices.js';
import * as Clipboard from 'clipboard';
import * as jquery from 'jquery';
import _ from 'lodash';
import Pikaday from 'pikaday';
import Popper from 'popper.js';
import store from 'store';
import { createApp } from 'vue';
import vSelect from 'vue-select';
import { defaultMeters } from '../common/metrics';
import AssistantFieldsComponent from './components/AssistantFields.vue';
import FeedbackAssistantSelector from './components/AssistantSelector.vue';
import BranchComponent from './components/BranchComponent.vue';
import CharacterConfigurator from './components/CharacterConfigurator.vue';
import UsageComponent from './components/charts/Usage.vue';
import CohortFieldsEditor from './components/CohortFieldsEditor.vue';
import ContentBuilderComponent from './components/ContentBuilderComponent.vue';
import ContentListComponent from './components/ContentListComponent.vue';
import FacilitatorComponent from './components/Facilitator.vue';
import GroupBuilderComponent from './components/GroupBuilderComponent.vue';
import GroupListComponent from './components/GroupListComponent.vue';
import LeaderboardComponent from './components/Leaderboard.vue';
import ModelParameterFields from './components/ModelParameterFields.vue';
import ModelSelect from './components/ModelSelect.vue';
import PageSelector from './components/PageSelector.vue';
import TestRunEchoListener from './components/TestRunEchoListener.vue';
import VectorStoreFileUploader from './components/VectorStoreFileUploader.vue';
import VersionHistoryComponent from './components/VersionHistory.vue';
window['_'] = _;
window['Clipboard'] = Clipboard;
window['Choices'] = Choices;
window['Popper'] = Popper;
window['Pikaday'] = Pikaday;
window['store'] = store;
window['beautify'] = beautify;
window['QuillEditor'] = QuillEditor;
window['defaultMeters'] = defaultMeters;
window['VueSelect'] = vSelect;
window['contentBuilderComponent'] = ContentBuilderComponent;
window['facilitatorComponent'] = FacilitatorComponent;
window['contentListComponent'] = ContentListComponent;
window['branchComponent'] = BranchComponent;
window['groupListComponent'] = GroupListComponent;
window['assistantFieldsComponent'] = AssistantFieldsComponent;
window['assistantSelector'] = FeedbackAssistantSelector;
window['pageSelector'] = PageSelector;
window['cohortFieldsEditor'] = CohortFieldsEditor;
window['characterConfiguratorComponent'] = CharacterConfigurator;
window['modelSelectComponent'] = ModelSelect;
window['modelParameterFieldsComponent'] = ModelParameterFields;
window['vueMonacoEditorPlugin'] = VueMonacoEditorPlugin;
window['createApp'] = createApp;
const app = createApp({});
app.component('group-builder', GroupBuilderComponent);
app.component('facilitator', FacilitatorComponent);
app.component('leaderboard', LeaderboardComponent);
app.component('assistant-fields', AssistantFieldsComponent);
app.component('vector-store-file-uploader', VectorStoreFileUploader);
app.component('feedback-assistant-selector', FeedbackAssistantSelector);
app.component('page-selector', PageSelector);
app.component('chart-usage', UsageComponent);
app.component('input-tag', VueTagsInput);
app.component('test-run', TestRunEchoListener);
app.component('version-history', VersionHistoryComponent);
app.component('character-configurator', CharacterConfigurator);
window['App'] = app;
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */
window['$'] = window['jQuery'] = jquery;
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window['axios'] = axios;
window['axios'].defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window['axios'].defaults.headers.common['x-api-token'] = window['apiToken'];
/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience, so we don't have to attach every token manually.
 */
const token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window['axios'].defaults.headers.common['X-CSRF-TOKEN'] = token['content'];
}
else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
// Make the component available globally so other Vue apps can use it
window['VersionHistoryComponent'] = VersionHistoryComponent;
